import { render, staticRenderFns } from "./ChannelEditModalForm.vue?vue&type=template&id=13845322"
import script from "./ChannelEditModalForm.vue?vue&type=script&lang=js"
export * from "./ChannelEditModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports